import React from 'react';
import DelayComponent from "../DelayComponent";

function ForbiddenAccess() {
  return (
      <DelayComponent>
        <div>
          <span style={{ color: 'red' }}>
            Недостаточно прав для просмотра страницы
          </span>
        </div>
      </DelayComponent>
  );
}

export default ForbiddenAccess;
